<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xl-3 col-md-6">
        <stats-card>
          <div slot="header" class="icon-warning">
            <i class="nc-icon nc-money-coins text-primary"></i>
          </div>
          <div slot="content">
            <p class="card-category">Pesos</p>
            <h5 class="card-title">
              <span v-if="isCuentasLoading">Cargando...</span
              ><span v-else>
                <vue-numeric
                  read-only
                  currency="$"
                  thousand-separator="."
                  decimal-separator=","
                  :value="getTotalEnPesos"
                ></vue-numeric>
              </span>
            </h5>
          </div>
        </stats-card>
      </div>

      <div class="col-xl-3 col-md-6">
        <stats-card>
          <div slot="header" class="icon-success">
            <i class="nc-icon nc-money-coins text-success"></i>
          </div>
          <div slot="content">
            <p class="card-category">Dólares</p>
            <h5 class="card-title">
              <span v-if="isCuentasLoading">Cargando...</span
              ><span v-else>
                <vue-numeric
                  read-only
                  currency="U$D"
                  thousand-separator="."
                  decimal-separator=","
                  :value="getTotalEnDolar"
                ></vue-numeric>
              </span>
            </h5>
          </div>
        </stats-card>
      </div>

      <div class="col-xl-3 col-md-6">
        <stats-card>
          <div slot="header" class="icon-danger">
            <i class="nc-icon nc-bank text-secondary"></i>
          </div>
          <div slot="content">
            <p class="card-category">Cheques</p>
            <h5 class="card-title">
              <span v-if="isCuentasLoading">Cargando...</span
              ><span v-else>
                <vue-numeric
                  read-only
                  currency="$"
                  thousand-separator="."
                  decimal-separator=","
                  :value="getTotalEnCheque"
                ></vue-numeric>
              </span>
            </h5>
          </div>
        </stats-card>
      </div>

      <div class="col-xl-3 col-md-6">
        <stats-card>
          <div slot="header" class="icon-info">
            <i class="nc-icon nc-money-coins text-danger"></i>
          </div>
          <div slot="content">
            <p class="card-category">Pesos a cobrar</p>
            <h5 class="card-title">
              <span v-if="isCuentasLoading">Cargando...</span
              ><span v-else>
                <vue-numeric
                  read-only
                  currency="$"
                  thousand-separator="."
                  decimal-separator=","
                  :value="getTotalEnPesosPendientes"
                ></vue-numeric
              ></span>
            </h5>
          </div>
        </stats-card>
      </div>
    </div>
  </div>
</template>

<script>
import StatsCard from "@/components/Cards/StatsCard";
import vueNumeric from "../../../lib/utils/vue-numeric.vue";

export default {
  name: "EstadosDeCuentaTotales",
  components: { StatsCard, vueNumeric },
  computed: {
    getTotalEnPesos() {
      const value = this.$store.getters["cuentas/getTotalEnPesos"];
      return parseFloat(value);
    },
    getTotalEnDolar() {
      const value = this.$store.getters["cuentas/getTotalEnDolar"];
      return parseFloat(value);
    },
    getTotalEnCheque() {
      const value = this.$store.getters["cuentas/getTotalEnCheque"];
      return parseFloat(value);
    },
    getTotalEnPesosPendientes() {
      const value = this.$store.getters["cuentas/getTotalEnPesosPendientes"];
      return parseFloat(value);
    },
    isCuentasLoading() {
      return this.$parent.isCuentasLoading;
    },
  },
};
</script>

<style scoped></style>
